<div class="card-box">
  <a href="solicitud?card={{type}}&origen=OcaE2E" role="button" class="btn btn-md btn-primary">{{
    description
  }}</a>
  <figure class="card-box__image mb-4 mb-lg-5">
    <img [src]="image" [alt]="alternative" />
  </figure>
</div>
